import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Flex } from '@chakra-ui/react';

const FitContent = ({
  children,
  debug = false,
  lockScroll = false,
  chatDotsActive = false,
  mt = 0,
  mb = 0,
  pt = 0,
  pb = 0,
  px = `1rem`,
  itemSpacing = `1rem`,
  onComponentDidMount = () => {}
}) => {
  const fitterRef = useRef(null);

  const [fitterRefOffset, setFitterRefOffset] = useState(0);

  const [dimensions, setDimensions] = useState({
    offsetHeight: window.innerHeight - fitterRefOffset,
    h: window.innerHeight,
    w: window.innerWidth
  });

  const handleResize = useCallback(() => {
    const parentOffset = fitterRef.current ? fitterRef.current.offsetTop : 0;
    setFitterRefOffset(parentOffset);

    const nextDimensions = {
      offsetHeight: window.innerHeight - parentOffset,
      h: window.innerHeight,
      w: window.innerWidth
    };

    setDimensions(nextDimensions);
  }, []);

  useEffect(() => {
    window.addEventListener(`resize`, handleResize);

    return () => {
      window.removeEventListener(`resize`, handleResize);
    };
  }, [handleResize]);

  useEffect(() => {
    handleResize();
  }, [handleResize, fitterRef]);

  useEffect(() => {
    onComponentDidMount();
  }, []);

  /* These two effect hooks may not be required, and is worth noting that
   * they may be a bottleneck for performance. */
  useEffect(() => {
    if (lockScroll) {
      return;
    }

    const parentOffset = fitterRef.current ? fitterRef.current.offsetTop : 0;
    setFitterRefOffset(parentOffset);

    const nextDimensions = {
      offsetHeight: window.innerHeight - parentOffset,
      h: window.innerHeight,
      w: window.innerWidth
    };

    setDimensions(nextDimensions);

    fitterRef.current.scrollTo({
      top: fitterRef.current.scrollHeight,
      behavior: `smooth`
    });
  }, [lockScroll, chatDotsActive]);

  return (
    <Flex
      ref={fitterRef}
      overflow={lockScroll ? `hidden` : `auto`}
      flexDir="column-reverse"
      w="100%"
      height={`${dimensions.offsetHeight}px`}
      border={debug ? `3px solid red` : ``}
      mt={mt}
      mb={mb}
      pt={pt}
      pb={pb}
      px={px}>
      <Flex
        w="100%"
        border={debug ? `2px solid purple` : ``}
        sx={{
          div: debug
            ? {
                border: `2px solid orange`
              }
            : null
        }}
        mx="auto"
        spacing={itemSpacing}
        maxW="31.25rem"
        flexDir="column">
        {children}
      </Flex>
    </Flex>
  );
};

export default FitContent;
